<template>
    <div>
        <div
            class="faq-item js-faq-item"
            :class="{ active : question.active }"
            @click="activateItem"
        >
            <div class="faq-question">
                {{ question.question }}
            </div>

            <div class="faq-answer" :ref="question.ref" :style="{ maxHeight : activeMaxHeight }">
                <div class="faq-answer-content" v-html="question.answer"></div>
            </div>

        </div>
    </div>
</template>

<script>

import ScrollsToTarget from "../../../Mixins/ScrollsToTarget.js";

export default {

    name: "FaqQuestion",

    mixins: [ScrollsToTarget],

    props: ['question-data', 'categoryRef'],

    data() {
        return {
            activeMaxHeight: 0,
        }
    },

    created() {
        this.question = this.questionData;

        this.Bus.on('open-category', (reference) => {
            this.openQuestion(reference);
        });

        this.Bus.on('close-all-faq-questions-' + this.categoryRef, this.deactivateItem);
    },

    mounted() {
        this.$nextTick(() => {
            if (this.question.active) {
                this.activeMaxHeight = this.$refs[this.question.ref].scrollHeight + 'px';
            }
        });
    },

    methods: {

        openQuestion(reference) {

            if (reference === this.categoryRef) {

                this.setHeights();

                let target = document.querySelector('div[data-scroll-target="faq"]');

                if (target) {
                    this.scrollTo(target.offsetTop - 32, 300);
                }

            }
        },

        setHeights() {
            this.$nextTick(() => {
                if (this.question.active) {
                    this.activeMaxHeight = this.$refs[this.question.ref].scrollHeight + 'px';
                }
            });
        },

        activateItem(e) {

            let activated = this.question.active;

            this.Bus.emit('close-all-faq-categories-' + this.categoryRef);

            let url = this.question.urlCategory;

            if (! activated) {

                let target = e.currentTarget;

                if (target) {
                    this.scrollTo(target.offsetTop - 1, 300);

                    setTimeout(() => {
                        this.question.active = true;
                        this.activeMaxHeight = this.$refs[this.question.ref].scrollHeight + 'px';
                        url = this.question.url;
                    }, 300);
                }
            }

            history.pushState(null, null, url);
        },

        deactivateItem() {
            this.question.active = false;
            this.activeMaxHeight = 0;
        }
    }
}
</script>

<style scoped>

</style>
